export default __webpack_public_path__ + "static/media/cook2.6288c01c.jpeg";